import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import Login from '@/views/login.vue'
import LoginCode from '@/views/loginCode.vue'
import Register from '@/views/register.vue'
import ResetPwd from '@/views/resetPwd.vue'
import Home from '@/views/index.vue'
import Dynamic from '@/views/PersonCenter/dynamic/index.vue'
import Collect from '@/views/PersonCenter/collect/index.vue'
import RealNameAuth from '@/views/PersonCenter/realNameAuth/index.vue'
import Wallet from '@/views/PersonCenter/wallet/index.vue'
import Recharge from '@/views/PersonCenter/wallet/recharge.vue'
import Setting from '@/views/PersonCenter/setting/index.vue'
import About from '@/views/PersonCenter/about/index.vue'
import Chat from '@/views/Conversation/chat.vue'
import WithDrawal from '@/views/PersonCenter/wallet/withDrawal.vue'
import AuthSfz from '@/views/PersonCenter/wallet/authSfz.vue'
import SetPwd from '@/views/PersonCenter/setPwd/index.vue'
import ResetPayPwd from '@/views/PersonCenter/setPwd/resetPwd.vue'
import EditProfile from '@/views/PersonCenter/profile/editProfile.vue'
import BankCard from '@/views/PersonCenter/wallet/bankCard.vue'
import BillingRecord from '@/views/PersonCenter/wallet/billingRecord.vue'
import Shop from '@/views/shop/index.vue'
import ShopDetail from '@/views/shop/detail.vue'
import Pay from '@/views/shop/pay.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login
  },
  {
    path: '/LoginCode',
    name: 'LoginCode',
    component: LoginCode
  },
  {
    path: '/Register',
    name: 'Register',
    component: Register
  },
  {
    path: '/ResetPwd',
    name: 'ResetPwd',
    component: ResetPwd
  },
  {
    path: '/Dynamic',
    name: 'Dynamic',
    component: Dynamic
  },
  {
    path: '/Collect',
    name: 'Collect',
    component: Collect
  },
  {
    path: '/RealNameAuth',
    name: 'RealNameAuth',
    component: RealNameAuth
  },
  {
    path: '/Wallet',
    name: 'Wallet',
    component: Wallet
  },
  {
    path: '/Recharge',
    name: 'Recharge',
    component: Recharge
  },
  {
    path: '/Setting',
    name: 'Setting',
    component: Setting
  },
  {
    path: '/About',
    name: 'About',
    component: About
  },
  {
    path: '/Chat',
    name: 'Chat',
    component: Chat
  },
  {
    path: '/WithDrawal',
    name: 'WithDrawal',
    component: WithDrawal
  },
  {
    path: '/AuthSfz',
    name: 'AuthSfz',
    component: AuthSfz
  },
  {
    path: '/SetPwd',
    name: 'SetPwd',
    component: SetPwd
  },
  {
    path: '/ResetPayPwd',
    name: 'ResetPayPwd',
    component: ResetPayPwd
  },
  {
    path: '/EditProfile',
    name: 'EditProfile',
    component: EditProfile
  },
  {
    path: '/BankCard',
    name: 'BankCard',
    component: BankCard
  },
  {
    path: '/BillingRecord',
    name: 'BillingRecord',
    component: BillingRecord
  },
  {
    path: '/Shop',
    name: 'Shop',
    component: Shop
  },
  {
    path: '/ShopDetail',
    name: 'ShopDetail',
    component: ShopDetail
  },
  {
    path: '/Pay',
    name: 'Pay',
    component: Pay
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const authData = JSON.parse(localStorage.getItem('authData') || '{}')

  // 登录和验证码登录页面不需要验证
  if (!authData.token && (to.path === '/Login' || to.path === '/LoginCode' || to.path === '/Register' || to.path === '/ResetPwd')) {
    next()
    return
  }

  // 其他页面需要验证是否登录
  if (!authData.token) {
    next('/Login')
    return
  }

  // 已登录状态下访问登录页,跳转到首页
  if (to.path === '/Login' || to.path === '/LoginCode') {
    next('/')
    return
  }

  // 正常放行
  next()
  // 在这里执行你的逻辑
  // 如果你想允许导航，调用 next()
  // 如果你想阻止导航，调用 next(false)
  // 如果你想导航到不同的位置，调用 next('/path')
})

export default router
